import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from '../../../../../components/Link/Link';
import { Gray } from '../../../../../constants/styles';
const List = styled.ul `
  list-style: none;
  padding: 0 15px 30px;
`;
const ListItem = styled.li `
  border-bottom: 1px solid ${Gray.x200};
  height: 51px;

  &:first-child {
    border-top: 1px solid ${Gray.x200};
  }
`;
const StyledLink = styled(Link) `
  display: inline-flex;
  align-items: center;
  gap: 0 4px;
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  font-weight: 300;
  line-height: 1;
  height: 100%;
  padding: 16px 0;
  text-decoration: none;
  width: 100%;
`;
export const MobileLinksList = ({ links }) => (_jsx(List, { children: links.map(({ name, url, onClick, badge }) => (_jsx(ListItem, { children: _jsxs(StyledLink, Object.assign({ href: url, onClick: onClick }, { children: [name, badge] }), void 0) }, url))) }, void 0));
//# sourceMappingURL=MobileLinksList.js.map